import { render, staticRenderFns } from "./InstitutionDetails.vue?vue&type=template&id=11cbd50f"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports